const IconOptionsEnum = {
  DRIVER: { icon: "truck", color: "#4A4A4A" },
  DELIVERED: { icon: "pack", color: "#409E6A" },
  PENDING: { icon: "pack", color: "#c1c1c1" },
  ON_ROUTE: { icon: "pack", color: "#f5cb2b" },
  UNDELIVERED : { icon: "pack", color: "#f54c53" },
  DELIVERED_OWN_COLLECT: { icon: "ownCollect", color: "#AB47BC" },
  PENDING_OWN_COLLECT: { icon: "ownCollect", color: "#E1BEE7" },
  UNDELIVERED_OWN_COLLECT: { icon: "ownCollect", color: "#481389" },
  DEFAULT: { icon: "default", color: "#B3B3B3" },
};

export default IconOptionsEnum;
